
export const GET_DOCUMENT_TYPE_LIST_URL = "getdocumentlist";
export const GET_SIGNED_DOC_URL = "getsigneddocurl";
export const UPLOAD_DOCUMENT_FILE = "uploaddocumentfile";
export const GET_S3_CREDENTIALS_URL = "gets3credentails";